import React from "react";
import styled from "styled-components";
import { LayoutContext } from "contexts/layout";
import { useContext } from "react";
import { navigate } from "infra/router/history";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Link,
  SvgIcon,
} from "@material-ui/core";
import useGuias from "../../../../../actions/guias/useGuias";

const Image = styled.img`
  max-width: 150px;
  margin-bottom: 32px;
  @media screen and (max-width: 768px) {
    max-width: 120px;
  }
`;

const Text = styled.span`
  font-size: 1rem;
  font-weight: 600;
  color: ${(props) => (props.theme === 2 ? "#333333" : "#ffffff")};
  @media screen and (max-width: 360px) {
    font-size: 0.8rem;
  }
`;
const StyledLink = styled(Link)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 12px 12px;
  background-color: ${(props) => (props.theme === 1 ? "#333333" : "#ffffff")};
`;

const StyledSvgIcon = styled(SvgIcon)`
  margin-right: 8px;
`;

const StyledDownloadContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
`;

const Container = styled.div`
  padding: 32px;
  max-width: 768px;
  margin: auto;
  display: flex;
  min-height: 100vh;

  flex-direction: column;
  background-color: ${(props) => (props.theme === 2 ? "#333333" : "#ffffff")};
  * {
    text-align: center;
  }
  p {
    color: ${(props) => (props.theme === 1 ? "#333333" : "#ffffff")};
  }
`;
export const Divider = styled.div`
  width: 100%;
  margin: 16px 0;
  height: 1px;
  background-color: gray;
`;
const LinkContainer = styled.div`
  b {
    font-weight: 600;

    color: ${(props) => (props.theme === 2 ? "#333333" : "#ffffff")};
  }
`;

function QRCode() {
  const { layoutData } = useContext(LayoutContext);
  const { guias = [] } = useGuias();
  const [openWifi, setOpenWifi] = React.useState(false);

  const templateColor = layoutData?.templateLinkQrCode ?? 1;
  return (
    <Container theme={templateColor}>
      {openWifi && (
        <ModalWifi
          open={openWifi}
          onClose={() => setOpenWifi(false)}
          wifi={{ rede: layoutData.wifiRede, senha: layoutData.wifiSenha }}
        />
      )}
      <div>
        <Image src={layoutData.logo} onClick={() => navigate("/")} />
      </div>
      <p theme={templateColor} style={{ fontSize: 14 }}>
        {layoutData?.mensagemPadrao}
      </p>
      <LinkContainer>
        {layoutData.flgWGAtivoMenuSeguranca ? (
          <>
            {guias?.map((guia) => {
              return (
                <div style={{ display: "flex", marginTop: 8 }}>
                  <StyledLink
                    theme={templateColor}
                    onClick={() => navigate(`menu/${guia.id}`)}
                  >
                    <Text theme={templateColor}>{guia.nome}</Text>
                  </StyledLink>
                </div>
              );
            })}
          </>
        ) : null}
        <div style={{ lineHeight: "26px" }}>
          <div style={{ margin: "8px 0" }}>
            <b style={{ color: templateColor === 2 ? "#ffffff" : "#333333" }}>
              Cardápio Presencial
            </b>
          </div>

          <StyledLink theme={templateColor} onClick={() => navigate("menu")}>
            <Text theme={templateColor}>Completo</Text>
          </StyledLink>
        </div>

        {layoutData.flgWGAtivoDeliverySeguranca ? (
          <>
            <Divider />

            <div style={{}}>
              <StyledLink
                theme={templateColor}
                onClick={() => navigate("delivery")}
              >
                <Text theme={templateColor}>Delivery</Text>
              </StyledLink>
            </div>
          </>
        ) : null}
        {layoutData.fidelidadeId > 0 ? (
          <div style={{ marginTop: 8, display: "flex", lineHeight: "26px" }}>
            <StyledLink
              theme={templateColor}
              onClick={() => navigate("fidelidade")}
            >
              <Text theme={templateColor}>Fidelidade</Text>
            </StyledLink>
          </div>
        ) : null}
        {layoutData.flgPedidoPontoEntrega ? (
          <div style={{ marginTop: 8, display: "flex", lineHeight: "26px" }}>
            <StyledLink
              theme={templateColor}
              onClick={() => navigate("delivery-ponto-entrega")}
            >
              <Text theme={templateColor}>Pedido - Ponto de Entrega</Text>
            </StyledLink>
          </div>
        ) : null}
        {layoutData.flgStatusReservaMesaAtiva === "A" || layoutData.flgStatusReservaMesaAtiva === "P" ? (
          <div style={{ marginTop: 8, display: "flex", lineHeight: "26px" }}>
            <StyledLink
              theme={templateColor}
              onClick={() => navigate("reserva")}
            >
              <Text theme={templateColor}>Reserva</Text>
            </StyledLink>
          </div>
        ) : null}
        {layoutData.flgRetornaWhatsApp ? (
          <div style={{ marginTop: 8, display: "flex", lineHeight: "26px" }}>
            <StyledLink
              theme={templateColor}
              onClick={() =>
                window.open(
                  `http://wa.me/${layoutData.telefoneWhatsApp}`,
                  "_blank"
                )
              }
            >
              <StyledSvgIcon>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.9031 3.03437C11.5938 1.72187 9.85 1 7.99687 1C4.17187 1 1.05937 4.1125 1.05937 7.9375C1.05937 9.15938 1.37813 10.3531 1.98438 11.4062L1 15L4.67812 14.0344C5.69063 14.5875 6.83125 14.8781 7.99375 14.8781H7.99687C11.8188 14.8781 15 11.7656 15 7.94063C15 6.0875 14.2125 4.34687 12.9031 3.03437ZM7.99687 13.7094C6.95937 13.7094 5.94375 13.4312 5.05937 12.9062L4.85 12.7812L2.66875 13.3531L3.25 11.225L3.1125 11.0063C2.53437 10.0875 2.23125 9.02812 2.23125 7.9375C2.23125 4.75938 4.81875 2.17188 8 2.17188C9.54062 2.17188 10.9875 2.77187 12.075 3.8625C13.1625 4.95312 13.8313 6.4 13.8281 7.94063C13.8281 11.1219 11.175 13.7094 7.99687 13.7094ZM11.1594 9.39062C10.9875 9.30313 10.1344 8.88438 9.975 8.82812C9.81563 8.76875 9.7 8.74062 9.58438 8.91562C9.46875 9.09062 9.1375 9.47813 9.03438 9.59688C8.93438 9.7125 8.83125 9.72812 8.65938 9.64062C7.64062 9.13125 6.97188 8.73125 6.3 7.57812C6.12188 7.27187 6.47812 7.29375 6.80937 6.63125C6.86562 6.51562 6.8375 6.41563 6.79375 6.32812C6.75 6.24062 6.40313 5.3875 6.25938 5.04063C6.11875 4.70312 5.975 4.75 5.86875 4.74375C5.76875 4.7375 5.65312 4.7375 5.5375 4.7375C5.42188 4.7375 5.23438 4.78125 5.075 4.95312C4.91562 5.12813 4.46875 5.54688 4.46875 6.4C4.46875 7.25313 5.09063 8.07813 5.175 8.19375C5.2625 8.30938 6.39687 10.0594 8.1375 10.8125C9.2375 11.2875 9.66875 11.3281 10.2188 11.2469C10.5531 11.1969 11.2437 10.8281 11.3875 10.4219C11.5312 10.0156 11.5312 9.66875 11.4875 9.59688C11.4469 9.51875 11.3313 9.475 11.1594 9.39062Z"
                    fill="#189D0E"
                  />
                </svg>
              </StyledSvgIcon>

              <Text theme={templateColor}>Nosso WhatsApp</Text>
            </StyledLink>
          </div>
        ) : null}

        {layoutData.wifiRede && layoutData.wifiSenha ? (
          <div style={{ marginTop: 8 }}>
            <StyledLink theme={templateColor} onClick={() => setOpenWifi(true)}>
              <Text theme={templateColor}>Rede WiFi</Text>
            </StyledLink>
          </div>
        ) : null}

        {layoutData.tripAdvisor ? (
          <div style={{ marginTop: 8, display: "flex", lineHeight: "26px" }}>
            <StyledLink
              theme={templateColor}
              onClick={() =>
                window.open(`${layoutData?.tripAdvisor}`, "_blank")
              }
            >
              <StyledSvgIcon>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="16" height="16" rx="16" fill="#34E0A1" />
                  <path
                    d="M13.019 6.33086L14 5.2226H11.8263C10.699 4.426 9.36694 4 8.00333 4C6.63972 4 5.30767 4.426 4.18042 5.2226H2L2.98104 6.33086C2.39736 6.88995 2.05119 7.66663 2.01851 8.49042C1.98583 9.31421 2.2693 10.1178 2.80672 10.7248C3.34413 11.3319 4.09158 11.6928 4.885 11.7283C5.67843 11.7638 6.45302 11.471 7.03875 10.9142L8 12L8.96062 10.9149C9.38854 11.3265 9.92281 11.5996 10.498 11.7008C11.0731 11.8019 11.6642 11.7267 12.1989 11.4843C12.7335 11.2419 13.1884 10.8429 13.5078 10.3362C13.8273 9.82942 13.9975 9.23694 13.9975 8.6313H13.9969C13.9974 8.19826 13.9107 7.76989 13.7423 7.37371C13.5738 6.97753 13.3275 6.62231 13.019 6.33086ZM5.00125 10.7377C4.59996 10.7377 4.20768 10.6142 3.87402 10.3827C3.54036 10.1513 3.2803 9.8223 3.12674 9.4374C2.97317 9.0525 2.93299 8.62897 3.01128 8.22036C3.08957 7.81175 3.2828 7.43642 3.56656 7.14183C3.85031 6.84724 4.21184 6.64662 4.60542 6.56534C4.999 6.48407 5.40696 6.52578 5.7777 6.68521C6.14844 6.84464 6.46532 7.11463 6.68827 7.46103C6.91121 7.80743 7.03021 8.21469 7.03021 8.6313C7.03021 9.18997 6.81644 9.72575 6.43594 10.1208C6.05544 10.5158 5.53936 10.7377 5.00125 10.7377ZM8 8.57053C8 7.18433 7.02875 5.99496 5.74813 5.48647C6.46162 5.1778 7.22693 5.01888 7.9999 5.01888C8.77286 5.01888 9.53817 5.1778 10.2517 5.48647C8.97104 5.99518 8 7.18455 8 8.57053ZM10.9975 10.7377H10.9973C10.4591 10.7377 9.94297 10.5157 9.56243 10.1206C9.18189 9.72552 8.96811 9.18966 8.96813 8.63093C8.96814 8.07219 9.18194 7.53634 9.5625 7.14126C9.94306 6.74617 10.4592 6.52422 10.9974 6.52422C11.5356 6.52422 12.0517 6.74617 12.4323 7.14126C12.8128 7.53634 13.0267 8.07219 13.0267 8.63093C13.0267 9.18966 12.8129 9.72552 12.4324 10.1206C12.0518 10.5157 11.5357 10.7377 10.9975 10.7377ZM5.00125 7.52693H5.00104C4.79065 7.52693 4.58499 7.5917 4.41005 7.71305C4.23512 7.8344 4.09878 8.00688 4.01826 8.20868C3.93775 8.41048 3.91669 8.63253 3.95773 8.84676C3.99878 9.06098 4.10009 9.25776 4.24886 9.41221C4.39762 9.56666 4.58717 9.67184 4.79351 9.71445C4.99986 9.75707 5.21375 9.7352 5.40812 9.65161C5.6025 9.56802 5.76863 9.42647 5.88552 9.24486C6.0024 9.06325 6.06479 8.84973 6.06479 8.6313V8.62893C6.06466 8.48407 6.03704 8.34066 5.98352 8.20688C5.92999 8.0731 5.85162 7.95158 5.75286 7.84925C5.6541 7.74692 5.53689 7.66579 5.40793 7.61049C5.27897 7.55518 5.14078 7.52679 5.00125 7.52693ZM10.9975 7.52693C10.7871 7.52693 10.5814 7.5917 10.4065 7.71305C10.2316 7.8344 10.0952 8.00688 10.0147 8.20868C9.93421 8.41048 9.91315 8.63253 9.95419 8.84676C9.99523 9.06098 10.0965 9.25776 10.2453 9.41221C10.3941 9.56666 10.5836 9.67184 10.79 9.71445C10.9963 9.75707 11.2102 9.7352 11.4046 9.65161C11.599 9.56802 11.7651 9.42647 11.882 9.24486C11.9989 9.06325 12.0613 8.84973 12.0613 8.6313C12.0613 8.33841 11.9492 8.05751 11.7497 7.8504C11.5502 7.64329 11.2796 7.52693 10.9975 7.52693Z"
                    fill="black"
                  />
                </svg>
              </StyledSvgIcon>

              <Text theme={templateColor}>Avalie no trip advisor</Text>
            </StyledLink>
          </div>
        ) : null}
        <StyledDownloadContainer>
          {layoutData.urlDownloadAndroid ? (
            <div style={{ marginTop: 16, marginRight: 2 }}>
              <a
                href={layoutData.urlDownloadAndroid}
                rel="noopener noreferrer"
                target="_blank"
              >
                <img src="/images/apple-store.png" alt="Apple Store" />
              </a>
            </div>
          ) : (
            <div style={{ marginTop: 16, marginRight: 2 }}>
              <a
                href={
                  "https://apps.apple.com/us/app/webgula/id1462601021?l=pt&ls=1"
                }
                rel="noopener noreferrer"
                target="_blank"
              >
                <img src="/images/apple-store.png" alt="Apple Store" />
              </a>
            </div>
          )}
          {layoutData.urlDownloadIOS ? (
            <div style={{ marginTop: 16, marginLeft: 2 }}>
              <a
                href={layoutData.urlDownloadIOS}
                rel="noopener noreferrer"
                target="_blank"
              >
                <img src="/images/google-play.png" alt="Google Play" />
              </a>
            </div>
          ) : (
            <div style={{ marginTop: 16, marginLeft: 2 }}>
              <a
                href={
                  "https://play.google.com/store/apps/details?id=com.tactonuvem.webgula"
                }
                rel="noopener noreferrer"
                target="_blank"
              >
                <img src="/images/google-play.png" alt="Google Play " />
              </a>
            </div>
          )}
        </StyledDownloadContainer>
      </LinkContainer>
    </Container>
  );
}

const ModalWifi = ({ open, onClose, wifi: { rede, senha } }) => {
  return (
    <div>
      <Dialog open={open} onClose={onClose} aria-labelledby="form-dialog-title">
        <div style={{ textAlign: "center" }}>
          <DialogTitle id="form-dialog-title">WiFi</DialogTitle>
          <DialogContent>
            <div> Nome da rede:</div>
            <b>{rede}</b>
            <div> Senha:</div>
            <b>{senha}</b>
          </DialogContent>
        </div>
      </Dialog>
    </div>
  );
};
export default QRCode;
